import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

const useSlugEnd = () => {
  const pathname = usePathname();

  const slugEnd = useMemo(() => {
    if (!pathname) {
      return null;
    }

    return pathname.split('/').pop();
  }, [pathname]);

  return slugEnd;
};

export default useSlugEnd;
